import Vue from 'vue';
import Vuetify from 'vuetify';
import { scoolTheme } from '@/config/theme';
import Page from '@/plugins/Page';
import { debounce } from 'lodash';
import Quill from 'quill';
import MagicUrl from 'quill-magic-url';
Quill.register('modules/magicUrl', MagicUrl);
Vue.use(Page);
Vue.use(Vuetify, {
    theme: scoolTheme,
});
Vue.prototype.$debounce = debounce(function (methodName, ...parameters) {
    this[methodName].call(this, ...parameters);
}, 1000);
